/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

export const REQUEST_PRICE_RATES = 'REQUEST_PRICE_RATES';
export const REQUEST_PRICE_RATES_SUCCESS = 'REQUEST_PRICE_RATES_SUCCESS';
export const REQUEST_PRICE_RATES_FAILURE = 'REQUEST_PRICE_RATES_FAILURE';

export const REQUEST_PRICE_RATE = 'REQUEST_PRICE_RATE';
export const REQUEST_PRICE_RATE_SUCCESS = 'REQUEST_PRICE_RATE_SUCCESS';
export const REQUEST_PRICE_RATE_FAILURE = 'REQUEST_PRICE_RATE_FAILURE';

export const REQUEST_ADD_PRICE_RATE = 'REQUEST_ADD_PRICE_RATE';
export const REQUEST_ADD_PRICE_RATE_SUCCESS = 'REQUEST_ADD_PRICE_RATE_SUCCESS';
export const REQUEST_ADD_PRICE_RATE_FAILURE = 'REQUEST_ADD_PRICE_RATE_FAILURE';

export const REQUEST_UPDATE_PRICE_RATE = 'REQUEST_UPDATE_PRICE_RATE';
export const REQUEST_UPDATE_PRICE_RATE_SUCCESS = 'REQUEST_UPDATE_PRICE_RATE_SUCCESS';
export const REQUEST_UPDATE_PRICE_RATE_FAILURE = 'REQUEST_UPDATE_PRICE_RATE_FAILURE';

export const REQUEST_DELETE_PRICE_RATE = 'REQUEST_DELETE_PRICE_RATE';
export const REQUEST_DELETE_PRICE_RATE_SUCCESS = 'REQUEST_DELETE_PRICE_RATE_SUCCESS';
export const REQUEST_DELETE_PRICE_RATE_FAILURE = 'REQUEST_DELETE_PRICE_RATE_FAILURE';

export const REQUEST_ORIGIN_PRICE_RATE = 'REQUEST_ORIGIN_PRICE_RATE';
export const REQUEST_ORIGIN_PRICE_RATE_FAILURE = 'REQUEST_ORIGIN_PRICE_RATE_FAILURE';
export const REQUEST_ORIGIN_PRICE_RATE_SUCCESS = 'REQUEST_ORIGIN_PRICE_RATE_SUCCESS';

export const REQUEST_DESTINATION_PRICE_RATE = 'REQUEST_DESTINATION_PRICE_RATE';
export const REQUEST_DESTINATION_PRICE_RATE_FAILURE = 'REQUEST_DESTINATION_PRICE_RATE_FAILURE';
export const REQUEST_DESTINATION_PRICE_RATE_SUCCESS = 'REQUEST_DESTINATION_PRICE_RATE_SUCCESS';

export const REQUEST_ESTIMATED_PRICE_RATE = 'REQUEST_ESTIMATED_PRICE_RATE';
export const REQUEST_ESTIMATED_PRICE_RATE_FAILURE = 'REQUEST_ESTIMATED_PRICE_RATE_FAILURE';
export const REQUEST_ESTIMATED_PRICE_RATE_SUCCESS = 'REQUEST_ESTIMATED_PRICE_RATE_SUCCESS';
